module.exports = "<app-menu></app-menu>\n<router-outlet (activate)=\"changeOfRoutes()\"></router-outlet>\n<app-footer></app-footer>"